/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../common/time';
import '../../../common/currency';
import '../../../common/tender';
import '../../../common/entry_method';
import '../../../common/payment';
import './request';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "beemo": {
        "nested": {
          "api": {
            "nested": {
              "v2": {
                "nested": {
                  "reporting": {
                    "nested": {
                      "UnsuccessfulPayment": {
                        "fields": {
                          "paymentToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "billToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "status": {
                            "type": "squareup.beemo.api.v2.reporting.UnsuccessfulPayment.Status",
                            "id": 3,
                            "rule": "optional"
                          },
                          "authorizationTime": {
                            "type": "squareup.common.time.DateTime",
                            "id": 4,
                            "rule": "optional"
                          },
                          "voidTime": {
                            "type": "squareup.common.time.DateTime",
                            "id": 5,
                            "rule": "optional"
                          },
                          "authorizationMoney": {
                            "type": "squareup.common.Money",
                            "id": 6,
                            "rule": "optional"
                          },
                          "cardBrand": {
                            "type": "squareup.common.tender.CardTenderType",
                            "id": 7,
                            "rule": "optional"
                          },
                          "panSuffix": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "cardEntryMethod": {
                            "type": "squareup.common.PayWithSquareEntryMethod",
                            "id": 9,
                            "rule": "optional"
                          },
                          "offlinePayment": {
                            "type": "bool",
                            "id": 10,
                            "rule": "optional"
                          },
                          "dataSource": {
                            "type": "squareup.beemo.api.v2.reporting.UnsuccessfulPayment.DataSource",
                            "id": 11,
                            "rule": "optional"
                          },
                          "squareProduct": {
                            "type": "squareup.common.payment.SquareProduct",
                            "id": 12,
                            "rule": "optional"
                          },
                          "felicaBrand": {
                            "type": "squareup.common.tender.FelicaCard.FelicaBrand",
                            "id": 13,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Status": {
                            "values": {
                              "AUTH": 0,
                              "DECLINE": 1,
                              "VOID": 2,
                              "EXPIRED": 3
                            }
                          },
                          "DataSource": {
                            "values": {
                              "QUEUEBERT": 1,
                              "SQUARE_WEB": 2,
                              "SPOT": 3
                            }
                          }
                        }
                      },
                      "UnsuccessfulPaymentsReportRequest": {
                        "fields": {
                          "requestParams": {
                            "type": "squareup.beemo.api.v2.reporting.RequestParams",
                            "id": 1,
                            "rule": "optional"
                          },
                          "batchRequest": {
                            "type": "squareup.beemo.api.v2.reporting.UnsuccessfulPaymentsReportRequest.BatchRequest",
                            "id": 2,
                            "rule": "optional"
                          },
                          "includeStatus": {
                            "type": "squareup.beemo.api.v2.reporting.UnsuccessfulPayment.Status",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "includeSquareProduct": {
                            "type": "squareup.common.payment.SquareProduct",
                            "id": 4,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "BatchRequest": {
                            "fields": {
                              "batchSize": {
                                "type": "int32",
                                "id": 1,
                                "rule": "optional",
                                "options": {
                                  "default": 20
                                }
                              },
                              "batchToken": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "UnsuccessfulPaymentsReportResponse": {
                        "fields": {
                          "unsuccessfulPayment": {
                            "type": "squareup.beemo.api.v2.reporting.UnsuccessfulPayment",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "nextBatchToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.UnsuccessfulPayment && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.UnsuccessfulPayment?.nested?.Status && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.UnsuccessfulPayment?.nested?.DataSource && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.UnsuccessfulPaymentsReportRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.UnsuccessfulPaymentsReportRequest?.nested?.BatchRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.UnsuccessfulPaymentsReportResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UnsuccessfulPayment @ squareup/beemo/v2/reporting/unsuccessful_payments.proto at 12:1
 */
export const UnsuccessfulPayment = $root.lookupType('squareup.beemo.api.v2.reporting.UnsuccessfulPayment');
fixType(UnsuccessfulPayment);
Builder.createAndAttachToType(UnsuccessfulPayment);
/**
 * Payment status represents the latest state of the payment.
 *
 * SOURCE Status @ squareup/beemo/v2/reporting/unsuccessful_payments.proto at 23:3
 */
UnsuccessfulPayment.Status = $root.lookupEnum('squareup.beemo.api.v2.reporting.UnsuccessfulPayment.Status').values;
/**
 * SOURCE DataSource @ squareup/beemo/v2/reporting/unsuccessful_payments.proto at 70:3
 */
UnsuccessfulPayment.DataSource = $root.lookupEnum('squareup.beemo.api.v2.reporting.UnsuccessfulPayment.DataSource').values;
/**
 * SOURCE UnsuccessfulPaymentsReportRequest @ squareup/beemo/v2/reporting/unsuccessful_payments.proto at 89:1
 */
export const UnsuccessfulPaymentsReportRequest = $root.lookupType('squareup.beemo.api.v2.reporting.UnsuccessfulPaymentsReportRequest');
fixType(UnsuccessfulPaymentsReportRequest);
Builder.createAndAttachToType(UnsuccessfulPaymentsReportRequest);
/**
 * SOURCE BatchRequest @ squareup/beemo/v2/reporting/unsuccessful_payments.proto at 92:3
 */
UnsuccessfulPaymentsReportRequest.BatchRequest = $root.lookupType('squareup.beemo.api.v2.reporting.UnsuccessfulPaymentsReportRequest.BatchRequest');
fixType(UnsuccessfulPaymentsReportRequest.BatchRequest);
Builder.createAndAttachToType(UnsuccessfulPaymentsReportRequest.BatchRequest);
/**
 * SOURCE UnsuccessfulPaymentsReportResponse @ squareup/beemo/v2/reporting/unsuccessful_payments.proto at 116:1
 */
export const UnsuccessfulPaymentsReportResponse = $root.lookupType('squareup.beemo.api.v2.reporting.UnsuccessfulPaymentsReportResponse');
fixType(UnsuccessfulPaymentsReportResponse);
Builder.createAndAttachToType(UnsuccessfulPaymentsReportResponse);